import { Controls, Player } from '@lottiefiles/react-lottie-player'
import React from 'react'

const GlobalLoadingUi = () => {
    return (
        <div role="dialog" aria-modal="true" className="fade image-modal modal show text-center overflow-hidden transition-all" id="global-loading"
            style={{ display: "none", backgroundColor: "rgb(27 27 27 / 60%)", zIndex: 3004 }}>
            <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: 3004, overflow: 'hidden' }}>
                <Player src={process.env.PUBLIC_URL + "/loading/loading-dots.json"} background="rgba(0, 0, 0, 0)" speed="1" loop autoplay style={{ height: 250 }}>
                    <Controls visible={false} />
                </Player>
            </div>
        </div>
    )
}

export default GlobalLoadingUi